export const getCountryFromUrl = (url) => {
    let tempCountry = url.split('/', 2).join('/')
    return tempCountry.replace(/\//g, '')
}
